import {ChangeDetectionStrategy, Component, inject, input, model, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseTag} from '@xmedical/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {OverlayModule, ScrollStrategy, ScrollStrategyOptions} from '@angular/cdk/overlay';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {SearchBoxDirective} from '../../directives/searchbox/searchbox.directive';

@Component({
    selector: 'xui-tag-search',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      MatFormFieldModule, MatChipsModule, MatIconModule, MatListModule,
      OverlayModule, ReactiveFormsModule, SearchBoxDirective
    ]
})
export class TagComponent implements OnInit {
  private scrollStrategyOptions = inject(ScrollStrategyOptions);

  readonly tags = model<BaseTag[]>([]);
  readonly searchObservable = input<((query: string) => Observable<any[]>) | null>(null);

  formControl = new UntypedFormControl();
  searchResults: BaseTag[] = [];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  scrollStrategy: ScrollStrategy = this.scrollStrategyOptions.block();

  get hasResults(): boolean {
    return this.searchResults.length > 0;
  }

  ngOnInit(): void {
    if (this.searchObservable() === null) {
      throw Error('SearchObservable is a required input');
    }
  }

  selectItem(tag: BaseTag) {
    this.addTag(tag);
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our Tag
    if (value) {
      const newTag = {
        id: 0,
        tag: value,
        hexColor: '#ffffff'
      } as BaseTag;
      this.addTag(newTag);
    }
    // Clear the input value
    event.chipInput?.clear();
  }

  remove(tag: BaseTag): void {
    const currentTags = this.tags();
    const index = currentTags.indexOf(tag);

    if (index >= 0) {
      this.tags.set(currentTags.filter((_, currentIndex) => currentIndex !== index));
    }
  }

  onSearchResults(results: BaseTag[]) {
    if (results === null) {
      results = [];
    }
    this.searchResults = results;
  }

  private addTag(tag: BaseTag) {
    this.tags.update(tags => [...tags, tag]);
    this.formControl.setValue('');
  }
}
